import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import JwtService from "@/common/jwt.service";
import { BASE_URL } from "@/common/config";

import store from "@/store";
import {
  RESET_AUTH_STATE,
  RESET_USER_STATE,
  RESET_LIVE_STREAM_STATE,
  RESET_COMMENT_STATE,
  RESET_NOTIFICATION_STATE,
  RESET_CLUB_STATE,
  RESET_SCHEDULE_STATE,
  LOGOUT
} from "../store/actions.type";

const ApiService = {
  init() {
    Vue.use(VueAxios, axios);
    Vue.axios.defaults.baseURL = BASE_URL;

    axios.interceptors.request.use(request => {
      if (process.env.NODE_ENV === "development") {
        console.log("Starting Request", request);
      }
      return request;
    });

    axios.interceptors.response.use(
      response => {
        if (process.env.NODE_ENV === "development") {
          console.log("Response:", response);
        }
        return response;
      },
      error => {
        if (
          error.response &&
          error.response.status &&
          error.response.status === 401
        ) {
          store.dispatch(RESET_AUTH_STATE);
          store.dispatch(RESET_USER_STATE);
          store.dispatch(RESET_LIVE_STREAM_STATE);
          store.dispatch(RESET_COMMENT_STATE);
          store.dispatch(RESET_NOTIFICATION_STATE);
          store.dispatch(RESET_CLUB_STATE);
          store.dispatch(RESET_SCHEDULE_STATE);
          store.dispatch(LOGOUT);
        }
        return Promise.reject(error);
      }
    );
  },
  setHeader() {
    const user = JSON.parse(JwtService.getUser());
    // Vue.axios.defaults.headers.common['Authorization'] = `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6NywiZW1haWwiOiJjaGFuYm85N0BnbWFpbC5jb20iLCJmaXJzdE5hbWUiOiJDaGFuIiwibGFzdE5hbWUiOiJCbyIsInJvbGVzIjpbInN0cmVhbWVyIl0sInN0cmVhbWVySWQiOjMsImNvdW50cnkiOiJraG1lciIsImlhdCI6MTU3MTU0Nzg2OCwiZXhwIjoxNTcyMTUyNjY4fQ.r-ireVWnveNbVrXa19GdQBdpg9tzvizQy0hHScQGo0c`
    Vue.axios.defaults.headers.common["Authorization"] = `Bearer ${user.token}`;
    Vue.axios.defaults.headers.common["Accept"] = "multipart/form-data";
  },
  setContentTypeHeader() {
    Vue.axios.defaults.headers.common["Accept"] = "application/json";
    Vue.axios.defaults.headers.common["Content-Type"] = "application/json";
  },
  async query(resource, params) {
    return Vue.axios.get(resource, params);
  },
  async get(resource, slug = "") {
    return Vue.axios.get(`${resource}/${slug}`);
  },
  async post(resource, params) {
    return Vue.axios.post(resource, params);
  },
  async update(resource, slug, params) {
    return Vue.axios.put(`${resource}/${slug}`, params);
  },
  async put(resource, params) {
    return Vue.axios.put(resource, params);
  },
  async delete(resource) {
    return Vue.axios.delete(resource);
  },
  async uploadFile(resource, data, onProgress = null) {
    let formData = new FormData();
    data.forEach(d => {
      formData.append(d.key, d.value);
    });

    return Vue.axios.post(resource, formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      },
      onUploadProgress: progressEvent => {
        if (onProgress) {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          onProgress(percentCompleted);
        }
      }
    });
  },
  // async uploadVideo
  async downloadFile(resource) {
    return Vue.axios.get(resource, {
      responseType: "blob"
    });
  }
};

export default ApiService;
